import React from 'react';

function WorkspaceState({ title, text, actionLabel, onAction, role }) {
  return (
    <div className="workspace-state" role={role}>
      <h2 className="workspace-state-title">{title}</h2>
      {text && <p className="workspace-state-text">{text}</p>}
      <button type="button" className="btn btn-primary" onClick={onAction}>
        {actionLabel}
      </button>
    </div>
  );
}

export default WorkspaceState;